import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchPaymentsByUserId,
  createPayment,
  updatePaymentById,
} from "./PaymentApi";

const initialState = {
  status: "idle",
  payments: [],
  errors: null,
  successMessage: null,
};

export const fetchPaymentsByUserIdAsync = createAsyncThunk(
  "payment/fetchPaymentsByUserIdAsync",
  async (userId) => {
    const payments = await fetchPaymentsByUserId(userId);
    return payments;
  }
);

export const createPaymentAsync = createAsyncThunk(
  "payment/createPaymentAsync",
  async (paymentData) => {
    const newPayment = await createPayment(paymentData);
    return newPayment;
  }
);

export const updatePaymentByIdAsync = createAsyncThunk(
  "payment/updatePaymentByIdAsync",
  async (update) => {
    const updatedPayment = await updatePaymentById(update);
    return updatedPayment;
  }
);

const paymentSlice = createSlice({
  name: "paymentSlice",
  initialState: initialState,
  reducers: {
    resetPaymentStatus: (state) => {
      state.status = "idle";
      state.errors = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch payments
      .addCase(fetchPaymentsByUserIdAsync.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchPaymentsByUserIdAsync.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.payments = action.payload;
      })
      .addCase(fetchPaymentsByUserIdAsync.rejected, (state, action) => {
        state.status = "rejected";
        state.errors = action.error;
      })

      // Create payment
      .addCase(createPaymentAsync.pending, (state) => {
        state.status = "pending";
      })
      .addCase(createPaymentAsync.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.payments.push(action.payload);
        state.successMessage = "Payment method added successfully";
      })
      .addCase(createPaymentAsync.rejected, (state, action) => {
        state.status = "rejected";
        state.errors = action.error;
      })

      // Update payment
      .addCase(updatePaymentByIdAsync.pending, (state) => {
        state.status = "pending";
      })
      .addCase(updatePaymentByIdAsync.fulfilled, (state, action) => {
        state.status = "fulfilled";
        const index = state.payments.findIndex(
          (payment) => payment._id === action.payload._id
        );
        if (index !== -1) {
          state.payments[index] = action.payload;
        }
        state.successMessage = "Payment method updated successfully";
      })
      .addCase(updatePaymentByIdAsync.rejected, (state, action) => {
        state.status = "rejected";
        state.errors = action.error;
      });
  },
});

// Selectors
export const selectPaymentStatus = (state) => state.paymentSlice.status;
export const selectPayments = (state) => state.paymentSlice.payments;
export const selectPaymentErrors = (state) => state.paymentSlice.errors;
export const selectPaymentSuccessMessage = (state) =>
  state.paymentSlice.successMessage;

export const { resetPaymentStatus } = paymentSlice.actions;
export default paymentSlice.reducer;
